import PropTypes from "prop-types";
import React, { useState, useMemo } from "react";
import { useDispatch } from "react-redux";
import ModalWrapper from "../modalWrapper";
import {useWindowSize} from "../../utils/customHooks";

const MultiLineTextEx = (props) => {

    const dispatch = useDispatch();

    const [extText, setExtText] = useState(null);

    const [width, height] = useWindowSize();

    const extFieldValue = useMemo(() => {
        if (!props?.fieldInfo?.EditorMethod)
            return null;

        const dict = props.fieldInfo.EditorMethod.split(",").reduce((obj, item) => {
            const [key, value] = item.split("=");
            obj[key] = value;
            return obj;
        }, {});

        return dict.EditField;
    }, [props?.fieldInfo?.EditorMethod]);

    const getExtText = async (e) =>
    {
        e?.stopPropagation();

        if (!extText) {
            const t = await getLongValue(extFieldValue)
            setExtText(t);
        }
        else
            setExtText(null);
    }

    const getLongValue = async (fieldName) => {
            const val = await dispatch(props.dataItem.getFieldLongValue(fieldName, props.rowIndex));
            return val.value;
    }

    if (!extFieldValue)
        return props.value;

    return (
        <div className={"multiline-text"}>
            <div className={"d-flex"}>
                <div>{props.value}</div>
                {!extText &&
                    <i className="fa fa-up-right-and-down-left-from-center v6 c-pointer pl-1 pr-2"
                       onClick={getExtText}/>
                }
                {!!extText && <i className={"fa fa-down-left-and-up-right-to-center v6 antipod pl-1 pr-2"}/>}
            </div>

            {!!extText &&
                <ModalWrapper>
                    <div className={"modal fade show d-block d-flex justify-content-center"} onClick={e => e?.stopPropagation()}>
                        <div className={"multiline-text-popup mt-auto mb-auto"}>
                            <div className={"multiline-text-popup-header d-flex justify-content-end"}>
                                <i className={"fa fa-close v6 c-pointer"} onClick={getExtText}/>
                            </div>
                            <div className={"multiline-text-popup-content"} style={{maxHeight: `${height - 100}px`}}>
                                {extText}
                            </div>

                        </div>
                    </div>
                </ModalWrapper>
            }

        </div>
    );
};

MultiLineTextEx.propTypes = {
    readOnly: PropTypes.bool,
    rowIndex: PropTypes.number,
    dataItem: PropTypes.object,
    fieldInfo: PropTypes.object,
    value: PropTypes.string,
    style: PropTypes.object
};

export default MultiLineTextEx;